const version = process.env.VUE_APP_VERSION;
const major = version?.split('.')[0];

export const storeKey = (): string => {
  return `store_V${major}`;
};
